import { render, staticRenderFns } from "./ApproveDetail.vue?vue&type=template&id=dcbcd7e8&scoped=true&"
import script from "./ApproveDetail.vue?vue&type=script&lang=js&"
export * from "./ApproveDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApproveDetail.vue?vue&type=style&index=0&id=dcbcd7e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbcd7e8",
  null
  
)

export default component.exports